export default "__VITE_ASSET__CoaQ6qTG__"